"use client";

import { ReviewsRow } from "../ReviewsRow";

export function ExistingCompanyNameStep({
  value,
  onChange,
  onContinue,
}: {
  value: string;
  onChange: (value: string) => void;
  onContinue: () => void;
}) {
  const canContinue = value.trim().length > 0;

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (canContinue) onContinue();
      }}
      // Vertically centred on phones. 134px is the nav (64) plus StepShell's
      // sticky header (~70), both of which sit above this step now that the
      // manage branch is numbered.
      className="mx-auto flex min-h-[calc(100dvh-134px)] w-full max-w-[832px] flex-col items-start justify-center gap-6 px-4 py-10 sm:min-h-0 sm:justify-start sm:gap-8 sm:px-6 sm:pb-24 sm:pt-12 lg:pt-[109px]"
    >
      <h1 className="font-suisse-intl-bold text-[28px] leading-tight text-white sm:text-4xl md:text-5xl lg:text-[56px] lg:leading-[71px]">
        Let&apos;s get down
        <br />
        to business
      </h1>

      {/* The export's line breaks are kept for desktop and dropped on phones,
          where the text needs to reflow. */}
      <p className="font-suisse-intl text-base leading-relaxed text-white sm:text-lg sm:leading-[28.8px]">
        Before incorporating your company in Hong Kong, you would need to ensure you have a{" "}
        <br className="max-sm:hidden" />
        <span className="font-suisse-intl-bold italic">unique company name.</span>{" "}
        <br className="max-sm:hidden" />
          <br className="max-sm:hidden" />
        Please provide the company name you desire, and we&apos;ll check its availability during the
        filing process
      </p>

      <ReviewsRow />

      <div className="flex w-full flex-col items-start gap-5 sm:gap-6">
        {/* Frosted field, matching the one on the register branch's company
            name step. */}
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Existing company name"
          aria-label="Existing company name"
          className="h-14 w-full rounded-[34px] bg-white/20 px-5 font-suisse-intl text-base text-white outline outline-2 -outline-offset-2 outline-white/[0.04] backdrop-blur-xl placeholder:text-white/50 focus:outline-white/30 sm:px-[25px]"
        />

        <button
          type="submit"
          disabled={!canContinue}
          className="flex h-14 w-full items-center justify-center rounded-full bg-white px-4 font-suisse-intl text-xl leading-5 text-[#2A4775] transition-opacity hover:opacity-90 disabled:pointer-events-none disabled:opacity-50"
        >
          Get Started
        </button>
      </div>
    </form>
  );
}
